const { __ } = wp.i18n;
const { Fragment, useState, useRef, useEffect } = wp.element;
const { select } = wp.data;

// import axios from "axios";
import BControls from "./BControls";
import BColor from "./BColor";
import BRangeControl from "./BRangeControl";
import BMediaUpload from "./BMediaUpload";
import Chapter from "./Chapter";
import Settings from "./Tabs/General/Settings";
import Overlay from "./Tabs/General/Overlay";
import Streaming from "./Tabs/General/Streaming";
import Subtitle from "./Tabs/General/Subtitle";
import Quality from "./Tabs/General/Quality";
import Watermark from "./Tabs/General/Watermark";

const { TabPanel, Panel, PanelBody, PanelRow, Button, __experimentalNumberControl: NumberControl, TextControl, FormToggle, SelectControl, TextareaControl, ButtonGroup, __experimentalUnitControl: UnitControl } = wp.components;
const { InspectorControls } = wp.blockEditor;
const { getCurrentPostId } = select("core/editor");

const BSettings = (props) => {
  const {
    props: { attributes, setAttributes, clientId },
    video,
  } = props;

  useEffect(() => {
    const newUniqueId = clientId.substr(0, 8);
    setAttributes({ uniqueId: newUniqueId });
  }, []);

  const postId = getCurrentPostId();

  const { additionalCSS, additionalID, poster, radius, width, endscreen, endscreenText, endscreenTextLink, streaming, chapters, speed, popup, popupType, popupBtnStyle, popupBtnText, popupBtnExists, popupBtnClass } = attributes;

  const [newChapterDraft, setNewChapterDraft] = useState({});
  const postType = select("core/editor").getCurrentPostType();

  const handleChapter = (chapter, index) => {
    const newChapters = [...chapters];
    newChapters[index] = chapter;
    setAttributes({ chapters: newChapters });
  };

  const handleAdd = () => {
    const newChapters = [...chapters];
    newChapters.push(newChapterDraft);
    setAttributes({ chapters: newChapters });
    setNewChapterDraft({});
  };

  const handleRemove = (itemIndex) => {
    const newChapters = [...chapters];
    setAttributes({ chapters: newChapters.filter((item, index) => index !== itemIndex) });
  };

  const handleSpeed = (control) => {
    const newSpeed = { ...speed };
    newSpeed[control] = !newSpeed[control];
    setAttributes({ speed: newSpeed });
  };

  const handleRef = () => {
    const panels = document.querySelectorAll("div.components-panel__body");
  };

  const panelRef = useRef(null);

  const generateThumb = () => {
    setAttributes({ posterTime: video.player.currentTime });
    video.getThumbnailFromSource(false, true);
    video.player.pause();
  };

  const data = [
    { id: 1, name: "Lily" },
    { id: 2, name: "Lucy" },
  ];

  return (
    <Fragment>
      <InspectorControls style={{ marginBottom: "40px" }}>
        {postType === "videoplayer" && (
          <PanelBody>
            <PanelRow>
              <div className="h5vp_front_shortcode">
                <input value={`[html5_video id=${postId}]`} />
                <span className="htooltip">{__("Copy To Clipboard", "h5vp")}</span>
              </div>
            </PanelRow>
          </PanelBody>
        )}

        {!poster && !streaming && (
          <div className="generateThumbButton">
            {/* <img src={loadingImg} /> */}
            <Button className="button button-primary" onClick={generateThumb}>
              {__("Generate Thumbnail", "h5vp")}
            </Button>
            <p>{__("(Experimental)", "h5vp")}</p>
          </div>
        )}

        <TabPanel
          className="bPSS"
          activeClass="active-tab"
          //onSelect={ onSelect }
          tabs={[
            {
              name: "general",
              title: "General",
              className: "general btTab",
            },
            {
              name: "controls",
              title: "Controls",
              className: "slider btTab",
            },
            {
              name: "style",
              title: "Style",
              className: "style btTab",
            },
          ]}
        >
          {(tab) => {
            return (
              <span>
                {tab.name == "general" && (
                  <span>
                    <Panel>
                      {/* {Settings } */}
                      <Settings attributes={attributes} setAttributes={setAttributes} />

                      <PanelBody ref={panelRef} onToggle={handleRef} title={__("Chapters", "h5vp")} initialOpen={false}>
                        {chapters.map((chapter, index) => (
                          <Chapter key={index} onRemove={() => handleRemove(index)} chapter={chapter} onChange={(newChapter) => handleChapter(newChapter, index)} />
                        ))}
                        <Chapter addNew={true} onAdd={handleAdd} chapter={newChapterDraft} onChange={(newChapter) => setNewChapterDraft(newChapter)} />
                      </PanelBody>

                      {/* {overlay tab} */}
                      <Overlay attributes={attributes} setAttributes={setAttributes} />

                      <PanelBody ref={panelRef} onToggle={handleRef} title={__("End Screen", "h5vp")} initialOpen={false}>
                        <PanelRow>
                          <label class="label" for="endscreen">
                            {__("Enable Endscreen", "h5vp")}
                          </label>
                          <FormToggle id="endscreen" checked={endscreen} onChange={() => setAttributes({ endscreen: !endscreen })} />
                        </PanelRow>
                        {endscreen && (
                          <Fragment>
                            <PanelRow>
                              <label htmlFor="" className="label display-block">
                                {__("endscreen text", "h5vp")}
                              </label>
                            </PanelRow>
                            <PanelRow>
                              <TextControl value={endscreenText} onChange={(endscreenText) => setAttributes({ endscreenText })} />
                            </PanelRow>
                            <PanelRow>
                              <label htmlFor="" className="label display-block">
                                {__("endscreen text link", "h5vp")}
                              </label>
                            </PanelRow>
                            <PanelRow>
                              <TextControl value={endscreenTextLink} onChange={(endscreenTextLink) => setAttributes({ endscreenTextLink })} />
                            </PanelRow>
                          </Fragment>
                        )}
                      </PanelBody>
                      {props?.props?.name == "html5-player/video" && (
                        <Fragment>
                          <Streaming attributes={attributes} setAttributes={setAttributes} />
                          {!streaming && (
                            <Fragment>
                              <Subtitle attributes={attributes} setAttributes={setAttributes} />
                              <Quality attributes={attributes} setAttributes={setAttributes} />
                            </Fragment>
                          )}
                          <PanelBody title={__("Speed", "h5vp")} initialOpen={false}>
                            {Object.keys(speed)
                              .sort()
                              .map((item) => {
                                return (
                                  <PanelRow>
                                    <label htmlFor={item} className="label">
                                      {__(item, "h5vp")}
                                    </label>
                                    <FormToggle id={item} checked={speed[item]} onChange={() => handleSpeed(item)} />
                                  </PanelRow>
                                );
                              })}
                          </PanelBody>
                        </Fragment>
                      )}
                      <PanelBody title={__("Popup", "h5vp")} initialOpen={false}>
                        <PanelRow>
                          <label htmlFor="popup" className="label">
                            {__("Enable Popup", "h5vp")}
                          </label>
                          <FormToggle id="popup" checked={popup} onChange={() => setAttributes({ popup: !popup })} />
                        </PanelRow>
                        {popup && (
                          <>
                            <SelectControl
                              value={popupType}
                              options={[
                                { label: "poster", value: "poster" },
                                { label: "Button", value: "button" },
                              ]}
                              onChange={(popupType) => {
                                setAttributes({ popupType });
                              }}
                            />
                            {popupType === "button" && (
                              <PanelRow>
                                <label className="label">{__("Use Exists Button", "h5vp")}</label>
                                <FormToggle id="popupBtnExists" checked={popupBtnExists} onChange={() => setAttributes({ popupBtnExists: !popupBtnExists })} />
                              </PanelRow>
                            )}
                            {popupType === "button" && popupBtnExists && (
                              <>
                                <PanelRow>
                                  <label className="label">{__("Button Class", "h5vp")}</label>
                                </PanelRow>
                                <TextControl value={popupBtnClass} onChange={(popupBtnClass) => setAttributes({ popupBtnClass })} />
                              </>
                            )}
                            {popupType === "button" && !popupBtnExists && (
                              <>
                                <PanelRow>
                                  <label className="label">{__("Color", "h5vp")}</label>
                                  <BColor value={popupBtnStyle?.color} onChange={(color) => setAttributes({ popupBtnStyle: { ...popupBtnStyle, color } })} />
                                </PanelRow>
                                <PanelRow>
                                  <label className="label">{__("Background Color", "h5vp")}</label>
                                  <BColor value={popupBtnStyle?.backgroundColor} onChange={(backgroundColor) => setAttributes({ popupBtnStyle: { ...popupBtnStyle, backgroundColor } })} />
                                </PanelRow>
                                <PanelRow>
                                  <label htmlFor="" className="label">
                                    {__("Font Size", "h5vp")}
                                  </label>
                                  <UnitControl
                                    onChange={(fontSize) => setAttributes({ popupBtnStyle: { ...popupBtnStyle, fontSize } })}
                                    value={popupBtnStyle?.fontSize}
                                    units={[
                                      { label: "px", value: "px", default: 16 },
                                      { label: "em", value: "1", default: 1 },
                                      { label: "rem", value: "1.6", default: 1.6 },
                                    ]}
                                  />
                                </PanelRow>
                                <PanelRow>
                                  <label className="label">{__("Button Text", "h5vp")}</label>
                                </PanelRow>
                                <TextControl value={popupBtnText} onChange={(popupBtnText) => setAttributes({ popupBtnText })} />
                              </>
                            )}
                          </>
                        )}
                      </PanelBody>

                      <Watermark attributes={attributes} setAttributes={setAttributes} />

                      <PanelBody title={__("Aditional", "h5vp")} initialOpen={false}>
                        <TextControl label="Additional ID" value={additionalID} onChange={(additionalID) => setAttributes({ additionalID })} />
                        <TextareaControl label={__("Additional CSS", "h5vp")} value={additionalCSS} onChange={(additionalCSS) => setAttributes({ additionalCSS })} />
                      </PanelBody>
                    </Panel>
                  </span>
                )}
                {tab.name == "controls" && <BControls attributes={attributes} setAttributes={setAttributes} />}
                {tab.name == "style" && (
                  <span>
                    <Panel>
                      <PanelBody ref={panelRef} onToggle={handleRef}>
                        <BRangeControl label={__("Width", "h5vp")} enable={{ eDevice: false }} value={width.number} unit={width.unit} max={1000} onChange={(number) => setAttributes({ width: { ...width, number } })} onChangeUnit={(unit) => setAttributes({ width: { number: 0, unit } })} />
                        <BRangeControl label={__("Round Corner", "h5vp")} enable={{ eDevice: false }} value={radius.number} unit={radius.unit} max={100} onChange={(number) => setAttributes({ radius: { ...radius, number } })} onChangeUnit={(unit) => setAttributes({ radius: { number: 0, unit } })} />
                      </PanelBody>
                    </Panel>
                  </span>
                )}
              </span>
            );
          }}
        </TabPanel>
      </InspectorControls>
      {/* <Thumbs player={player} setAttributes={setAttributes} attributes={attributes} setThumbModel={setThumbModel} thumbModel={thumbModel} /> */}
    </Fragment>
  );
};

export default BSettings;
